<template lang="pug">
.autocomplete
  ModalHelper(:columnType="helperColumnType", v-model="helperModalOpened")

  .d-flex.flex-row
    v-text-field(
      outlined,
      label="Search",
      placeholder="Start typing to Search",
      @input="onInputSearchTable"
      v-model="searchQuery"
    )
    .d-flex.pt-4.ml-4 Total: {{ total }}

  v-simple-table
    template(v-slot:default)
      thead
        tr
          th(rowspan="2") Action
          th(rowspan="2")
            span Occupation Code
            v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Occupation Code')"
            ) mdi-information
          th(rowspan="2")
            span Job title
            v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Job title')"
            ) mdi-information
          th(rowspan="2")
            span Qualifying terms
              v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Qualifying terms')"
            ) mdi-information
          th.text-center(rowspan="2")
            div Eligible for
            div Skilled Worker
            div route?
          th.text-center(colspan="4")
            span Salary rates
            v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Salary rates')"
            ) mdi-information
          th.text-center(rowspan="2")
            div Eligible for
            div PhD points?
            v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Eligible for PhD points?')"
            ) mdi-information
          th.text-center(rowspan="2")
            div Shortage
            div occupation list
            v-icon.ra-table-th-helper(
              color="primary",
              @click="openHelper('Shortage occupation list')"
            ) mdi-information
        tr
            th.text-left
              span Going rate (Option A)
                v-icon.ra-table-th-helper(
                color="primary",
                @click="openHelper('Going rate (Option A)')"
              ) mdi-information
            th.text-left
              span 90% (Option B)
              v-icon.ra-table-th-helper(
                color="primary",
                @click="openHelper('90% (Option B)')"
              ) mdi-information
            th.text-left
              span 80% (Options C&D)
              v-icon.ra-table-th-helper(
                color="primary",
                @click="openHelper('80% (Options C&D)')"
              ) mdi-information
            th.text-left
              span 70% (Option E)
              v-icon.ra-table-th-helper(
                color="primary",
                @click="openHelper('70% (Option E)')"
              ) mdi-information
      tbody
        tr(v-for="item in jobsList", :key="item.id")
          td
            v-btn(
              v-if="item.eligible_for_skilled_workers === 'Yes'",
              :disabled="item.id == input",
              @click="setJobTitle(item)"
            ) select
          td
            v-tooltip(v-if="item && item.soc_group && item.soc_group.length > 41", top)
              template(v-slot:activator="{ on }")
                span(v-on="on") {{ item.soc_group }}
              span {{ item.soc_group }}
            span(v-else) {{ item.soc_group }}
          td {{ item.job_title }}
          td {{ item.industry }}
          td {{ item.eligible_for_skilled_workers }}
          td {{ item.going_rate | gbp }}
          td {{ item.ninety_percent | gbp }}
          td {{ item.eighty_percent | gbp }}
          td {{ item.seventy_percent | gbp }}
          td {{ item.eligible_for_ph_d }}
          td {{ item.shortage_occupation_list }}
  v-pagination(v-model="page", :length="totalPages", :total-visible="7", class="mt-4")
</template>

<script>
import { SearchJobTitlesURL } from "@/utils/apiUrls";
import ModalHelper from "./JobTitlesHelper/Modal";

const listOfAt = ["CreatedAt", "DeletedAt", "UpdatedAt", "id"];

export default {
  name: "Input",

  props: ["answer_values", "value"],

  components: {
    ModalHelper,
  },

  data: () => ({
    jobsList: [],
    helperModalOpened: false,
    helperColumnType: null,
    searchQuery: '',
    page: 1,
    totalPages: 1,
    total: 0,
  }),

  computed: {
    input: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val + "");
      },
    },
  },

  mounted() {
    this.getJobsList()
  },

  watch: {
    page(val, oldVal) {
      if (val !== oldVal) {
        this.getJobsList()
      }
    }
  },

  methods: {
    setJobTitle(item) {
      this.$emit("input", item.id + "");
    },

    openHelper(header) {
      this.helperColumnType = header ?? "";
      this.helperModalOpened = true;
    },

    isInclude(k) {
      return listOfAt.includes(k);
    },

    onInputSearchTable() {
      this.page = 1;
      this.getJobsList();
    },

    getJobsList() {
      this.axios
        .post(SearchJobTitlesURL, {
            query: this.searchQuery ? this.searchQuery : 'a',
            page: this.page
        })
        .then((resp) => {
            this.jobsList = resp?.data?.job_titles;
            this.total = resp?.data?.count;
            this.totalPages = Math.ceil(this.total / 10);
        });
    },
  },
};
</script>